import React from 'react';
import '../styles/Whatsapp.css'; 
import { FaWhatsapp } from 'react-icons/fa'; 

const StickyWhatsAppButton = () => {
  const message = "I Am Intrested in Mahadev I'D";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/918949471009?text=${encodedMessage}`;

  return (
    <a
    href={whatsappLink}
      className="sticky-whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default StickyWhatsAppButton;
